export enum ContainerCardPresentation {
  GENERAL = 'general',
  TITLE = 'title',
  MEDIA = 'media',
  INFORMATION = 'information',
  INFORMATION_LARGE = 'information_large',
  LIST = 'list',
}
